import React from 'react';
import classNames from 'classnames';
import { VettedByProBanner } from '@fiverr-private/seller_pages_toolbox';
import { GigCategory } from '../../../types/seller-phoenix';
import { ProSubcategories } from './ProSubcategories';
import classes from './index.module.scss';

export enum SPACING_MODES {
    NORMAL = 'normal',
    LARGE = 'large',
}

interface ProOverviewProps {
    className?: string;
    proSubcategories: GigCategory[];
    spacingMode?: SPACING_MODES;
}

export const ProOverview: React.FC<ProOverviewProps> = ({
    className,
    proSubcategories = [],
    spacingMode = SPACING_MODES.NORMAL,
}) => (
    <div
        className={classNames(
            classes.container,
            {
                'm-b-12': spacingMode === SPACING_MODES.NORMAL && proSubcategories.length > 0,
                'm-b-24': proSubcategories.length === 0,
                [classes.largeSpacing]: spacingMode === SPACING_MODES.LARGE,
            },
            className
        )}
    >
        <VettedByProBanner marginY="6" />
        {proSubcategories.length > 0 && (
            <ProSubcategories
                proSubcategories={proSubcategories}
                titleClassName={classNames({
                    'm-b-12': spacingMode === SPACING_MODES.LARGE,
                })}
            />
        )}
    </div>
);
